var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z",
    fill: "#E62048"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 0.581543V15.4185C2.06817 14.2317 0 11.3574 0 8.00003C0 4.64265 2.06817 1.76832 5 0.581543Z",
    fill: "#03803D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 8C8 9.65685 6.65685 11 5 11C3.34315 11 2 9.65685 2 8C2 6.34315 3.34315 5 5 5C6.65685 5 8 6.34315 8 8Z",
    fill: "#FADF43"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.69995 6.69995H6.29995V8.39995C6.29995 9.11792 5.71792 9.69995 4.99995 9.69995C4.28198 9.69995 3.69995 9.11792 3.69995 8.39995V6.69995Z",
    fill: "#fff",
    stroke: "#E62048"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 8C15.75 12.2802 12.2802 15.75 8 15.75C3.71979 15.75 0.25 12.2802 0.25 8C0.25 3.71979 3.71979 0.25 8 0.25C12.2802 0.25 15.75 3.71979 15.75 8Z",
    stroke: "#000",
    strokeOpacity: 0.1,
    strokeWidth: 0.5
  })));
}

export default SvgPt;